/* eslint-disable import/prefer-default-export */
import {
  CANVAS_ACTION_TAGS,
  CanvasLoadedAction,
  CanvasLoadedInputData,
} from './CanvasLoadedAction';

// Create singleton instances
const canvasLoadedAction = new CanvasLoadedAction();

/**
 * Track canvas loaded statistics
 */
export function trackCanvasLoaded(input: CanvasLoadedInputData) {
  canvasLoadedAction.sendAction(input);
}

// Re-export tags for convenience
export { CANVAS_ACTION_TAGS };
